module.exports = __webpack_public_path__ + "static/media/NimbusSanL-Reg.09d8a7b7.woff2";